import airportImg from "../../../../images/contents/map/airfield/airport.svg";
import airportPaleImg from "../../../../images/contents/map/airfield/airport_pale.svg";

export const configAirportDh = {
  "index": {
    "Type": "JSON",
    "url": "%arinc_data_auth_api_url%/auth/airport",
    "update_interval": 999999,
    "retain": true,
    "cache": true
  },
  "data": {
    "Type": "GeoJSON",
    "url": "%arinc_data_url%/airport/%index%/airport.json",
    "cache": true,
    "Grid": {
      "MinZoom": 1,
      "MaxZoom": 1,
      "download_max": 32,
      "BoundingBox": {
        "West": -180,
        "South": -90,
        "East": 180,
        "North": 90
      }
    }
  }
}

export const configAirportLayer = {
  "Name": "Airport",
  "Renderer": "Airport",
  "Attributes": {
    "min_zoom": 6,
    "features": [
      {
        "style": {
          "default": {
            "type": "image",
            "width": 24,
            "height": 24,
            "offset_x": -12,
            "offset_y": -12,
            "url": airportImg,
            "label_target": "icao",
            "label_color": "rgb(76, 76, 76)",
            "font_size": 13
          },
          "dark": {
            "type": "image",
            "width": 24,
            "height": 24,
            "offset_x": -12,
            "offset_y": -12,
            "url": airportPaleImg,
            "label_target": "icao",
            "label_color": "rgb(192, 192, 192)",
            "font_size": 13
          }
        }
      }
    ]
  }
}